<template>
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.235 11.445C19.965 7.26 18.27 3.18 15.09 0C11.88 3.21 10.11 7.29 9.765 11.445C11.685 12.465 13.455 13.785 15 15.39C16.545 13.8 18.315 12.48 20.235 11.445V11.445ZM10.485 15.42C10.275 15.27 10.035 15.135 9.81 14.985C10.035 15.15 10.275 15.27 10.485 15.42ZM20.115 15.045C19.92 15.18 19.71 15.285 19.515 15.435C19.71 15.285 19.92 15.18 20.115 15.045ZM15 20.175C11.775 15.255 6.27 12 0 12C0 19.98 5.04 26.73 12.045 29.235C12.99 29.58 13.98 29.835 15 30C16.02 29.82 16.995 29.565 17.955 29.235C24.96 26.73 30 19.98 30 12C23.73 12 18.225 15.255 15 20.175Z"
      fill="currentColor"
    />
  </svg>
</template>
